module.exports = __webpack_public_path__ + "img/hill25.c791d2cf.jpg";